const c = {
  name: "Guitar",
  dimensions: { width: 20, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20.3 40" style="enable-background:new 0 0 20.3 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7.2,34v2h6v-2H7.2z"/>
		<path class="st0" d="M7.2,0h6v2h2v2h-2v2h2v2h-2v8.2c3.8,0.9,6.6,4.6,6.1,8.7c0,0.2,0,0.4,0,0.7c0,0.5,0.1,0.9,0.2,1.4l0,0
			l0.8,3.2c1.2,5-2.6,9.8-7.8,9.8H8c-5.1,0-8.9-4.8-7.8-9.8L1,27c0.2-0.7,0.2-1.4,0.1-2.1l0,0C1.1,24.6,1,24.3,1,24
			c0-3.7,2.6-6.9,6.1-7.7V8h-2V6h2V4h-2V2h2V0z M13.2,22.4c0.6,0.7,1,1.6,1,2.6c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4c0-1,0.4-1.9,1-2.6
			v-4.1C4.8,19.1,3,21.3,3,24c0,0.2,0,0.5,0,0.7c0.1,0.9,0,1.8-0.2,2.7l0,0l-0.8,3.3C1.3,34.4,4.1,38,8,38h4.4
			c3.9,0,6.7-3.6,5.8-7.3l-0.8-3.3c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.3,0-0.6,0-0.9l0,0c0.3-2.9-1.5-5.5-4.1-6.4V22.4z M9.2,21.1
			c0.3-0.1,0.7-0.1,1-0.1c0.3,0,0.7,0,1,0.1V10h-2V21.1z M11.2,2h-2v6h2V2z M8.2,25c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2
			c0-1.1-0.9-2-2-2C9.1,23,8.2,23.9,8.2,25z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Guitar
};
